<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="btn-close" @click="performCancel"></button>
    </template>
    <template v-slot:body>
      <coaching-wall
        ref="coachingWall"
        :to="to"
        @viewing="viewing"
        @edited="edited"
        @valid="valid"
        @sending="sending"
      />
      <overlay
        v-if="isSending"
        :notice="overlayNotice"
        :customStyle="customOverlayStyle"
        @cancel="hideOverlay"
      />
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6">
          <span class="me-2">id:</span>
          <span>{{ id }}</span>
        </div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <!-- <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="showOverlay"
            >
              Overlay
            </button> -->
            <button
              class="btn btn-primary me-2"
              v-show="isEdited"
              :disabled="!messageValid || isSending"
              @click="send"
            >
              <i class="fas fa-envelope"></i><span class="ms-2">Send</span>
            </button>
            <button
              type="button"
              class="btn btn-secondary me-2"
              @click="cancel"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
  <confirm-cancel
    :show="actionConfirmCancel"
    :confirmTitle="confirmTitleCancel"
    :confirmAction="confirmActionCancel"
    :cancelAction="cancelActionName"
    :confirmQuestion="confirmQuestionCancel"
    @closing="closeModal"
    @proceed="performCancel"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import CoachingWall from '@/Components/Coaching/coaching-wall'
import ZDialog from '@/Components/ZElements/Dialog.vue'
import Overlay from '@/Components/ZElements/Overlay'
import ConfirmCancel from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'coaching-dialog',
  components: {
    ZDialog,
    CoachingWall,
    Overlay,
    ConfirmCancel,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      isViewing: false,
      messageValid: false,
      isSending: false,
      customOverlayStyle: 'width: 100% !important; height: 100% !important;',
      overlayNotice: 'sending',
      isEdited: false,
      confirmTitleCancel: 'Confirm Cancel',
      confirmActionCancel: 'Yes, Cancel',
      cancelActionName: 'No',
      confirmQuestionCancel: 'Are you sure you wish to Cancel?',
      actionConfirmCancel: null,
    }
  },
  mounted() {
    this.isEdited = false
  },
  emits: ['close', 'changed'],
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('usercardio', ['columns']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Coaching Wall'
      return _title
    },
    id() {
      let _id = null
      if (this.show) {
        _id = this.show.user_id
      }
      return _id
    },
    to() {
      let _to = null
      if (this.show) {
        _to = {
          id: parseInt(this.show.user_id),
          user_id: parseInt(this.show.user_id),
          firstName: this.show.FirstName,
          lastName: this.show.LastName,
          nickName: this.show.NickName,
          avatar: this.show.Avatar,
          memberids:
            this.show.memberids !== undefined && this.show.memberids !== null
              ? this.show.memberids
              : null,
          type: 'notification',
        }
      }
      console.log('Coaching Dialog To', _to)
      return _to
    },
  },
  methods: {
    ...mapActions('usercardio', ['setCustomView']),
    ...mapActions('coaching', ['resetWallMessages', 'getNewMessageCount']),
    closeModal() {
      this.actionConfirmCancel = null
    },
    cancel() {
      this.actionConfirmCancel = true
    },
    performCancel() {
      this.isEdited = false
      this.actionConfirmCancel = null
      // this.resetWallMessages()
      this.getNewMessageCount({
        id: this.profile.id,
        memberId: this.show.user_id,
      })
      this.$emit('close')
    },
    viewing(is) {
      this.isViewing = is
    },
    edited(value) {
      this.isEdited = value
    },
    valid(is) {
      this.messageValid = is
    },
    sending(is) {
      this.isSending = is
    },
    send() {
      // console.log('Sending')
      this.$refs.coachingWall.send()
    },
    hideOverlay() {
      this.isSending = false
    },
    showOverlay() {
      this.isSending = true
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 750px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
</style>
